import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/word-unscrambler")({
  component: WordUnscramblerLayout,
});

function WordUnscramblerLayout() {
  return <Outlet />;
}
